import React from 'react'

import Input from 'coact/Input'


export default function (props) {
  return (
    <Input type="Number" {...props} />
  )
}



// WEBPACK FOOTER //
// ./src/components/PurchaseOrderEditor/ItemsEditor/ItemEditor/LensSpec/DegreeInput.jsx